import { render } from "./DocumentClassSubView.vue?vue&type=template&id=4e45ade8&ts=true"
import script from "./DocumentClassSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassSubView.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__